import React from 'react'
import { components } from 'react-select'

export const SingleValue = ({ children, ...props }) => <components.SingleValue {...props}>{children}</components.SingleValue>

export default SingleValue
